/* eslint-disable no-unused-vars */
import React from 'react'

import Layout from './layout.tsx'

export function wrapRootElement({ element }) {
  return <Layout>{element}</Layout>
}
